import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface Props {
  statusCode: string;
  showLabel?: boolean;
}

/**
 * Status indicator component
 * Displays a colored dot based on status code
 * O = OK (green), W = Warning (yellow), A = Alert (red), B = Blank (gray)
 */
export const StatusIndicator = ({ statusCode, showLabel = false }: Props) => {
  const theme = useTheme();

  const getStatusColor = () => {
    switch (statusCode) {
      case "O":
        return theme.palette.success.main;
      case "W":
        return theme.palette.warning.main;
      case "A":
        return theme.palette.error.main;
      default:
        return theme.palette.grey[400];
    }
  };

  const getStatusLabel = () => {
    switch (statusCode) {
      case "O":
        return "OK";
      case "W":
        return "Warning";
      case "A":
        return "Alert";
      default:
        return "N/A";
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: getStatusColor(),
        }}
      />
      {showLabel ? (
        <Typography variant="caption" color="text.secondary">
          {getStatusLabel()}
        </Typography>
      ) : null}
    </Box>
  );
};
